module.exports = __webpack_public_path__ + "img/regiter-icon06-selected.7802ff66.png";